import type { ProblemDetailsApi } from '@/types/api';

/**
 * Extracts error message from RTK Query error objects or other error types
 */
export const extractErrorMessage = (error: unknown): string => {
  if (typeof error === 'string') {
    return error;
  }

  if (error && typeof error === 'object') {
    const errorObj = error as Record<string, unknown>;

    if (errorObj.data && typeof errorObj.data === 'object') {
      const problemDetails = errorObj.data as ProblemDetailsApi;

      if (problemDetails.detail) {
        return problemDetails.detail;
      }

      if (problemDetails.title) {
        return problemDetails.title;
      }
    }

    // Handle a top-level ProblemDetails body (the raw JSON the API returns and
    // errorMiddleware parses), which is not wrapped in a `data` field.
    if (typeof errorObj.detail === 'string' && errorObj.detail) {
      return errorObj.detail;
    }

    if (typeof errorObj.title === 'string' && errorObj.title) {
      return errorObj.title;
    }

    if (typeof errorObj.message === 'string') {
      return errorObj.message;
    }

    if (errorObj.status && errorObj.data) {
      return `HTTP ${errorObj.status}: ${JSON.stringify(errorObj.data)}`;
    }

    try {
      if (Object.keys(errorObj).length === 0) {
        return 'An unknown error occurred';
      }

      return JSON.stringify(errorObj);
    } catch {
      return String(errorObj);
    }
  }

  return 'An unknown error occurred';
};
